(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["prelaunch-block"] && !Shopify.designMode) return;
  try {
    (function () {
    var KEY = 'blorem_vip_pl';
    function remembered() { try { return window.localStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
    function remember() { try { window.localStorage.setItem(KEY, '1'); } catch (e) {} }
    function publishLead(email, source) {
      try {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish('blorem_vip_lead', { email: email, source: source });
        }
      } catch (e) {}
      try { window.dispatchEvent(new CustomEvent('blorem:vip-lead', { detail: { email: email, source: source } })); } catch (e) {}
    }
    function subscribe(company, list, source, email) {
      var url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company);
      var body = { data: { type: 'subscription', attributes: { custom_source: source, profile: { data: { type: 'profile', attributes: { email: email } } } }, relationships: { list: { data: { type: 'list', id: list } } } } };
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' }, body: JSON.stringify(body) })
        .then(function (r) { if (!r.ok) throw new Error('klaviyo ' + r.status); return r; });
    }
    function init(root) {
      if (root.dataset.plReady) return;
      root.dataset.plReady = '1';
      var company = root.getAttribute('data-pl-company');
      var list = root.getAttribute('data-pl-list');
      var source = root.getAttribute('data-pl-source') || 'Site';
      var form = root.querySelector('[data-pl-form]');
      var thanks = root.querySelector('[data-pl-thanks]');
      function showThanks() { root.classList.add('is-thanks'); if (thanks) thanks.removeAttribute('hidden'); }
      if (!(window.Shopify && window.Shopify.designMode) && remembered()) showThanks();
      if (!form) return;
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var input = form.querySelector('input[type="email"]');
        var email = input ? input.value.trim() : '';
        form.classList.remove('is-error');
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) || !company || !list) { form.classList.add('is-error'); if (input) input.focus(); return; }
        form.classList.add('is-busy');
        subscribe(company, list, source, email).then(function () {
          form.classList.remove('is-busy'); remember(); publishLead(email, source); showThanks();
        }).catch(function () { form.classList.remove('is-busy'); form.classList.add('is-error'); });
      });
    }
    function all() { Array.prototype.forEach.call(document.querySelectorAll('[data-pl]'), init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', all);
  })();
  } catch(e) { console.error(e); }
})();

})();
